// 公共面 lowercase 别名 ↔ 后端契约 enum
// MERCH 是后端历史 enum 值(无法变更);前端公共面用 'merch' 隔离品牌词。

export const CHANNEL_ALIAS_TO_BACKEND = {
  taobao: "TAOBAO",
  tmall: "TMALL",
  "1688": "1688",
  weidian: "WEIDIAN",
  pdd: "PDD",
  douyin: "DOUYIN",
  jd: "JD",
  xianyu: "XIANYU",
  merch: "MERCH",
} as const satisfies Record<string, string>;

export type ChannelAlias = keyof typeof CHANNEL_ALIAS_TO_BACKEND;
export type ChannelBackend = (typeof CHANNEL_ALIAS_TO_BACKEND)[ChannelAlias];

// Keyed by UPPERCASE backend enum so lookups can normalize casing first.
// The backend is inconsistent: /product/search returns "TAOBAO"/"WEIDIAN",
// but /favorites/page returns a mix of "TAOBAO" AND lowercase "taobao" for the
// same channel. A case-sensitive map threw `Unknown backend channel: taobao`,
// which rejected the favorites-page query and rendered the whole list page as
// an error (#955). Normalize to upper before lookup. ("1688".toUpperCase() is
// still "1688", so digit-only enums are unaffected.)
const BACKEND_TO_ALIAS: Record<string, ChannelAlias> = Object.fromEntries(
  Object.entries(CHANNEL_ALIAS_TO_BACKEND).map(([k, v]) => [v.toUpperCase(), k as ChannelAlias]),
);

export function toBackendChannel(alias: ChannelAlias): ChannelBackend {
  return CHANNEL_ALIAS_TO_BACKEND[alias];
}

export function fromBackendChannel(backend: string): ChannelAlias {
  const alias = BACKEND_TO_ALIAS[backend.toUpperCase()];
  if (!alias) throw new Error(`Unknown backend channel: ${backend}`);
  return alias;
}
